import React from "react";

function AboutChoose({ t }) {
  return (
    <>
      <section className="featuresSection p-30">
        <div className="container">
          <h3 className="subtitle mb-3 text-capitalize">
            {t("why choose us")}
          </h3>
          <div className="row">
            <div className="col-lg-12">
              <div className="feature-box bg-white">
                <i className="icon-shipped" />
                <div className="feature-box-content">
                  <strong>{t("Our Vision")}</strong>
                  <p>
                    At EHL Life Sciences Pvt Ltd, our vision is to be a trusted
                    partner in healthcare, transforming lives through the power
                    of quality medicine. We aim to create a future where
                    healthcare is accessible, affordable, and of the highest
                    standard for all, regardless of geographic or economic
                    barriers. We aspire to continue the legacy of care,
                    compassion, and innovation, ensuring that every patient
                    receives the best possible care with every product we
                    deliver.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="feature-box bg-white">
                <i className="icon-us-dollar" />
                <div className="feature-box-content">
                  <strong>{t("Our Mission")}</strong>
                  <p>
                    Our mission is simple yet powerful: to improve lives by
                    producing safe, effective, and high-quality medicines.
                    Guided by our core values of integrity, care, and
                    innovation, we strive to lead the pharmaceutical industry
                    with products that adhere to the highest international
                    standards, such as WHO & GMP certifications. At SISLIFE
                    BIOTECH, we go beyond just manufacturing—we aim to build
                    trust within communities, ensure health comes first, and be
                    a beacon of quality healthcare that people can depend on.
                    Through rigorous research, development, and manufacturing,
                    we commit ourselves to fulfilling our promise of quality,
                    reliability, and transformative care for every patient we
                    serve.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutChoose;
